import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { modal } from '@/share/components';

import { ref, reactive, watch, unref, onMounted } from 'vue';
import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'user-dep-editor-form',
  props: {
    userId: {
      type: [Number, String],
      required: true
    },
    depId: {
      type: [Number, String],
      default: ''
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const formRef = ref();
    const props = __props;
    const depList = ref([]);
    const {
      runAsync: orgDepAddUserApi
    } = fetchApi('myOrgDepUser.addUser');
    const formData = reactive({
      depId: '',
      position: ''
    });
    watch(() => props.depId, val => {
      formData.depId = unref(val);
    }, {
      immediate: true
    });
    const formRules = reactive({
      depId: [{
        required: true,
        message: '部门不能为空'
      }]
    });
    const {
      runAsync: getOrgDepListApi
    } = fetchApi('myOrgDep.getList');
    const loadDepList = async () => {
      const {
        error,
        rows
      } = await getOrgDepListApi({});
      if (error) return;
      depList.value = [{
        id: '',
        name: '[未设置]'
      }, ...rows];
    };
    onMounted(() => {
      loadDepList();
    });
    const submit = async () => {
      if (!props.userId) {
        modal.notification.warning('未选择前用户，不能保存');
        return Promise.resolve(false);
      }
      if (!formRef.value) return Promise.resolve(false);
      const errors = await formRef.value.validate();
      if (errors) return Promise.resolve(false);
      const postData = {
        ...formData,
        userId: props.userId
      };
      const {
        error,
        ...res
      } = await orgDepAddUserApi(postData);
      if (error) return Promise.resolve(false);
      modal.notification.success('设置用户部门成功');
      return Promise.resolve(res || true);
    };
    __expose({
      confirmListener() {
        return submit();
      }
    });
    return (_ctx, _cache) => {
      const _component_vxe_select = _resolveComponent("vxe-select");
      const _component_vxe_form_item = _resolveComponent("vxe-form-item");
      const _component_vxe_input = _resolveComponent("vxe-input");
      const _component_vxe_form = _resolveComponent("vxe-form");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_vxe_form, {
        ref_key: "formRef",
        ref: formRef,
        "title-width": "120",
        "title-colon": "",
        "title-align": "right",
        data: _unref(formData),
        rules: _unref(formRules)
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_form_item, {
          span: "24",
          title: "部门",
          field: "depId"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_select, {
            options: _unref(depList),
            "option-props": {
              value: 'id',
              label: 'name'
            },
            modelValue: _unref(formData).depId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).depId = $event)
          }, null, 8, ["options", "modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_form_item, {
          span: "24",
          title: "职务",
          field: "position"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_input, {
            modelValue: _unref(formData).position,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(formData).position = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "rules"])]);
    };
  }
};